import React from 'react'

export const BasicClockIcon = (color = '#EBB428', width = 11, height = 10) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60938 7.10938L8.00781 6.45312L5.75781 5.09375V2.49219H5.00781V5.49219L7.60938 7.10938ZM1.96094 1.48438C2.94531 0.5 4.125 0.0078125 5.5 0.0078125C6.875 0.0078125 8.04688 0.5 9.01562 1.48438C10 2.45312 10.4922 3.625 10.4922 5C10.4922 6.375 10 7.55469 9.01562 8.53906C8.04688 9.50781 6.875 9.99219 5.5 9.99219C4.125 9.99219 2.94531 9.50781 1.96094 8.53906C0.992188 7.55469 0.507812 6.375 0.507812 5C0.507812 3.625 0.992188 2.45312 1.96094 1.48438Z"
        fill={color}
      />
    </svg>
  )
}
